import React from 'react';
import { useIntl } from 'react-intl';
import { CloseIcon } from '@panwds/icons';
import { Button } from '../Button/Button.esm.js';
import '@panwds/tailwindcss';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { CardHeader } from '../Card/CardHeader.esm.js';
import { useModalContext } from './Modal.esm.js';

function CloseButton(props) {
    const intl = useIntl();
    return (React.createElement(Button, { appearance: "tertiary-clear", "aria-label": intl.formatMessage({
            defaultMessage: 'Close modal',
            id: '4VwnfS',
            description: 'Label for a button to close a modal'
        }), icon: React.createElement(CloseIcon, { size: "xs", className: "dark:tw-text-gray-400" }), size: "sm", ...props }));
}
/**
 * A styled container to be used within a Modal.
 */
function ModalHeader({ actions, enableClose = true, ...passThrough }) {
    const { closeModalWithConfirm } = useModalContext();
    return (React.createElement(CardHeader, { ...passThrough, actions: React.createElement(React.Fragment, null,
            actions,
            enableClose && React.createElement(CloseButton, { onClick: closeModalWithConfirm })) }));
}

export { ModalHeader };
//# sourceMappingURL=ModalHeader.esm.js.map
